import { setAddressUserInputValidityErrorWithTracking } from './form-validation';
import { updateMap } from '../../../../../blocks/segments/address/address.events';

export const updateAddressUserInputValidityState = ({ form, geoObject, definedAddress, $rootScope, isNewOffer, isAddressCached }) => {
  const validitySetterOptions = {
    isAddressCached,
    isNewOffer,
    form,
    isValid: false,
  };

  if (definedAddress) {
    if (geoObject && ['locationRequired'].includes(geoObject.accuracyError)) {
      setAddressUserInputValidityErrorWithTracking({
        validator: 'needLocation',
        trackingLabel: 'need_location',
        ...validitySetterOptions,
      });

      $rootScope.$emit(updateMap, geoObject);
    } else if (definedAddress === 'street') {
      // требуем номер дома в Москве для не загородной недвижимости
      if (geoObject.accuracyError === 'houseRequired') {
        setAddressUserInputValidityErrorWithTracking({
          validator: 'needHouse',
          trackingLabel: 'need_house',
          ...validitySetterOptions,
        });
      }
    } else if (definedAddress === 'location') {
      // Требуем указать улицу для не загородной недвиж. (в Москве для всей)
      if (geoObject && ['streetRequired', 'houseRequired'].includes(geoObject.accuracyError)) {
        setAddressUserInputValidityErrorWithTracking({
          validator: 'needStreet',
          trackingLabel: 'need_street',
          ...validitySetterOptions,
        });
      }
    } else if (definedAddress !== 'house') {
      setAddressUserInputValidityErrorWithTracking({
        validator: 'needCity',
        trackingLabel: 'need_city',
        ...validitySetterOptions,
      });
    }
  } else if (geoObject && geoObject.status && geoObject.status === 'notFound') {
    setAddressUserInputValidityErrorWithTracking({
      validator: 'notFound',
      trackingLabel: 'not_found',
      ...validitySetterOptions,
    });
  } else if (geoObject && geoObject.status && geoObject.status === 'needAddress') {
    setAddressUserInputValidityErrorWithTracking({
      validator: 'needAddress',
      trackingLabel: 'need_address',
      ...validitySetterOptions,
    });
  } else {
    setAddressUserInputValidityErrorWithTracking({
      validator: 'serverError',
      trackingLabel: 'server_error',
      ...validitySetterOptions,
    });
  }
}
